import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { PageContainer } from "../PagesComponents";
import { useTranslation } from "next-i18next";
import Loader from "../Loader";

const GetQueryHoc = (Component, details) => {
  const { pageTitle, cacheKey, apiCall, apiOptions } = details;
  const AuthenticatedComponent = () => {
    const { t } = useTranslation();
    const { locale } = useRouter();

    const result = useQuery([cacheKey, locale], () => apiCall(locale), {
      staleTime: 0,
      refetchInterval: false,
      refetchOnWindowFocus: false,
      cacheTime: Infinity,
      ...apiOptions,
    });

    return (
      <PageContainer
        title={t(pageTitle)}
        {...result.data?.data.attributes.page_info}
      >
        {result.isLoading ? <Loader /> : <Component result={result} />}
      </PageContainer>
    );
  };

  return AuthenticatedComponent;
};

export default GetQueryHoc;
